<template>
  <v-card v-if="industry">
    <v-card-title>
      {{ industry.name }}
    </v-card-title>
    <v-card-subtitle class="caption">
      <v-row>
        <v-col cols="auto"> <span class="font-weight-bold">Id</span> {{ industry.id }} </v-col>
      </v-row>
    </v-card-subtitle>
    <v-divider />
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="industry.name"
              label="Name"
              outlined
              hide-details="auto"
            />
          </v-col>
          <v-col
            v-if="industry.popularity"
            cols="12"
          >
            <v-select
              v-model="industry.popularity.id"
              label="Popularity"
              :items="popularity"
              :rules="[$rules.required]"
              outlined
              hide-details="auto"
              item-value="id"
              item-text="name"
            />
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="industry.active"
              label="Active?"
              color="primary"
              inset
              hide-details
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="industry.excludeFromProfession"
              label="Exclude from Profession?"
              color="primary"
              inset
              hide-details
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="industry.groupId"
              label="Group"
              :items="groups"
              outlined
              hide-details="auto"
              item-value="id"
              item-text="name"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-text>
      <v-btn
        color="primary"
        :loading="saving"
        block
        @click="save"
      >
        Save
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'EditIndustry',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
    adding() {
      return !this.id;
    },
    title() {
      return `${this.industry.name} Details`;
    },
    industry: {
      get() {
        return this.$store.getters['industries/edit_industry'];
      },
      set(val) {
        this.$store.dispatch('industries/edit', val);
      }
    },
    ...mapGetters({ popularity: 'lookup/popularity', groups: 'lookup/industry_groups' })
  },

  async mounted() {},

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('industries/update', this.industry)
        .then(() => {
          this.$root.$snackbarSuccess('Industry saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
